var ThemeFontStyleTypeEnum;
(function (ThemeFontStyleTypeEnum) {
    ThemeFontStyleTypeEnum["bodySmall"] = "bodySmall";
    ThemeFontStyleTypeEnum["bodyMedium"] = "bodyMedium";
    ThemeFontStyleTypeEnum["bodyLarge"] = "bodyLarge";
    ThemeFontStyleTypeEnum["bodyXLarge"] = "bodyXLarge";
    ThemeFontStyleTypeEnum["headingXSmall"] = "headingXSmall";
    ThemeFontStyleTypeEnum["headingSmall"] = "headingSmall";
    ThemeFontStyleTypeEnum["headingMedium"] = "headingMedium";
    ThemeFontStyleTypeEnum["headingLarge"] = "headingLarge";
    ThemeFontStyleTypeEnum["headingXLarge"] = "headingXLarge";
    ThemeFontStyleTypeEnum["priceXSmall"] = "priceXSmall";
    ThemeFontStyleTypeEnum["priceSmall"] = "priceSmall";
    ThemeFontStyleTypeEnum["priceMedium"] = "priceMedium";
    ThemeFontStyleTypeEnum["priceLarge"] = "priceLarge";
    ThemeFontStyleTypeEnum["priceXLarge"] = "priceXLarge";
    ThemeFontStyleTypeEnum["priceXXLarge"] = "priceXXLarge";
})(ThemeFontStyleTypeEnum || (ThemeFontStyleTypeEnum = {}));
export default ThemeFontStyleTypeEnum;
//# sourceMappingURL=ThemeFontStyleTypeEnum.js.map